import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';

import { CloneMaterial, Material, Foam } from '@usimweb/core/models';
import { DropdownComponent } from '@usimweb/ui/shared';
import { DialogService } from '@usimweb/ui/dialogs';

import { BehaviorSubject } from 'rxjs';

import { InputType } from '../../../../core/enums/inpuTypeEnum';
import { MaterialDialogComponent } from 'apps/foaming/src/app/dialogs/material-dialog/material-dialog.component';

@Component({
    selector: 'app-material',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './material.component.html',
    styleUrls: ['./material.component.scss'],
    standalone: false
})
export class MaterialComponent implements OnInit, OnChanges {
  @Input() foams: Foam[] = [];

  @Output() selectionChangeMaterial: EventEmitter<any> = new EventEmitter<any>();

  @Output() selectionChangeUsimData: EventEmitter<any> = new EventEmitter<any>();

  public inputType = InputType;
  public material: Material = { material: '', recipes: '', temperatures: [] };

  public key = 'slug';
  public valueFoam = 'displayName';
  public valueUsimData = 'description';

  public selectedMaterial: number = 0;
  public selectedUsimData: string = '';

  public usimdatas: any[] = [];
  public usimdata: boolean = false;

  @ViewChild('tempMenu') tempMenu!: DropdownComponent;

  public setMaterialCallBack = new BehaviorSubject<boolean>(false);

  constructor(private dialogService: DialogService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.material = { material: '', recipes: '', temperatures: [] };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.foams) {
      this.foams.forEach((foam: Foam) => {
        foam.displayName = foam.group + ' ' + foam.name;
      });
    }
  }

  // private resetTemperatures() {
  //   this.temperatures = [];
  //   this.material.temperatures = [];

  //   // will be never reached ???
  //   if (this.material.temperatures.length > 0) {
  //     this.selectionChangeTemperature.emit(this.material.temperatures);
  //   }
  // }

  public setMaterialData(cloneMaterial: CloneMaterial) {
    setTimeout(() => {
      this.selectedMaterial = cloneMaterial.material;
      this.selectionChangedMaterial(this.selectedMaterial.toString());
      this.setMaterialCallBack.next(true);
    }, 1500);
  }

  public selectionChangedMaterial(slug: string) {
    this.usimdata = true;
    const foams = this.foams.find((x) => x.slug === slug)?.usimdata || [];
    this.usimdatas = foams;
    this.selectionChangeMaterial.emit(slug);
  }

  public selectionChangedUsimData(slug: string) {
    console.log('selected usimdata');
    console.log(slug);
    this.selectionChangeUsimData.emit(slug);
  }

  // public selectionChangedRecipe(recipes: string) {
  //   this.showTemperature = true;
  //   this.temperatureLoading = true;
  //   this.material.recipes = recipes;
  //   this.selectionChangeRecipe.emit(this.material.recipes);

  //   setTimeout(() => {
  //     this.tempMenu.deSelect();
  //   }, 500);
  // }

  // public selectionChangedTemperature(temperatures: any) {
  //   this.material.temperatures = temperatures;
  //   this.selectionChangeTemperature.emit(this.material.temperatures);
  // }

  public blur() {
    //this.updateMaterial.emit(this.material);
  }

  public openMaterialDetailDialog() {
    this.dialogService
      .openContentDialog(MaterialDialogComponent, this.foams, 'Material list', undefined, 80)
      .subscribe((material) => {
        if (material) {
          this.selectedMaterial = material;
          this.material.material = material;

          //this.resetTemperatures();
        }
      });
  }
}
